export const messages = {
  en: {
    adminGroupOrder: {
      queryCondition: 'Query Conditions',
      groupOrder: 'Group Orders',
      orderId: 'Order ID',
      productImage: 'Product Image',
      productName: 'Product Name',
      buyer: 'Buyer',
      groupLeader: 'Group Leader',
      buyCount: 'Purchase Quantity',
      groupCount: 'Group Members',
      groupAmount: 'Group Amount',
      status: 'Status',
      rebateAmount: 'Rebate Amount',
      openTime: 'Open Time',
      groupTime: 'Group Time',
      deadline: 'Deadline',
      search: 'Search',
      orderIdPlaceholder: 'Please enter order ID',
      prodNamePlaceholder: 'Please enter product name',
      buyerNamePlaceholder: 'Please enter buyer name',
      groupBuyerNamePlaceholder: 'Please select group leader',
      statePlaceholder: 'Please select status',
      allStatus: 'All Status',
      groupSuccess: 'Group Success',
      groupFail: 'Group Fail',
      grouping: 'Grouping',
      singlePrice: 'Single Price',
      validDate: 'Valid Date',
      hasRebate: 'Has Rebate',
      leaderRebate: 'Leader Rebate',
      groupPeople: 'Group People',
      groupPrice: 'Group Price',
      groupStartTime: 'Group Start Time'
    }
  },
  zh: {
    adminGroupOrder: {
      queryCondition: '查询条件',
      groupOrder: '拼团订单',
      orderId: '订单ID',
      productImage: '商品图片',
      productName: '商品名称',
      buyer: '购买者',
      groupLeader: '团长',
      buyCount: '购买数量',
      groupCount: '拼团人数',
      groupAmount: '拼团金额',
      status: '状态',
      rebateAmount: '返佣金额',
      openTime: '开团时间',
      groupTime: '拼团时间',
      deadline: '截止时间',
      search: '查询',
      orderIdPlaceholder: '请填写订单',
      prodNamePlaceholder: '请填写产品名称',
      buyerNamePlaceholder: '请填写购买者',
      groupBuyerNamePlaceholder: '请选择团长',
      statePlaceholder: '请选择状态',
      allStatus: '全部状态',
      groupSuccess: '拼团成功',
      groupFail: '拼团失败',
      grouping: '拼团中',
      singlePrice: '单买金额',
      validDate: '有效期',
      hasRebate: '是否返佣',
      leaderRebate: '团长返佣',
      groupPeople: '拼团人数',
      groupPrice: '拼团金额',
      groupStartTime: '开团时间'
    }
  }
}